import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CategoryItem } from 'src/app/core/_models/category-item';
import { NavigationItem } from 'src/app/core/_models/navigation-item';
import { CODE_PAGE_QUAN_HE_CO_DONG } from 'src/app/core/_models/predefined-code-list';
import { CategoryService } from 'src/app/core/_services/category.service';
import { NavigationService } from 'src/app/core/_services/navigation.service';
import { SiteLanguageService } from 'src/app/core/_services/site-language.service';
import { StateService } from 'src/app/core/_services/state.service';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerComponent implements OnInit {
  @Input() isOpenMenu = false;
  @Output() showSearch = new EventEmitter<boolean>();
  @Output() isCloseMenu = new EventEmitter<boolean>(false);
  expandMenuId = -1;
  isShowSearch = false;

  currentLanguage = 'vi';

  languageList = [
    { code: 'en', label: 'English' },
    { code: 'vi', label: 'Việt Nam' },
  ];

  advisoryNav?: NavigationItem;
  portfolioNav?: NavigationItem;
  navAboutUs?: {
    item: NavigationItem;
    children: {
      item: NavigationItem;
      children?: {
        item: NavigationItem;
      }[];
    }[];
  };

  knowledgeNav?: {
    item: NavigationItem;
    children: {
      item: NavigationItem;
      children?: {
        item: NavigationItem;
      }[];
    }[];
  };

  investmentFundsNav?: {
    item: NavigationItem;
    children: {
      item: NavigationItem;
      children?: {
        item: NavigationItem;
      }[];
    }[];
  };

  // InformationDisclosureAtHomePage
  iDAtHomePage: (NavigationItem | CategoryItem)[] = [];

  // For About Us
  shareholderRelationsNav?: NavigationItem;
  catInformationDisclosure?: CategoryItem;

  constructor(
    private _cateService: CategoryService,
    private _translate: TranslateService,
    private _stateService: StateService,
    private _navService: NavigationService,
    private _siteLangService: SiteLanguageService,
    private _cdr: ChangeDetectorRef,
  ) {
    this._stateService.currentLanguage$.subscribe({
      next: (currentLang: string) => {
        this.currentLanguage = currentLang;
        this._cdr.markForCheck();
      },
    });
  }

  ngOnInit(): void {
    this._stateService.navTree$.subscribe({
      next: () => {
        this.navAboutUs = this._navService.getAboutUsNav();
        this.advisoryNav = this._navService.getAdvisoryNav();
        this.portfolioNav = this._navService.getPortfolioNav();
        this.knowledgeNav = this._navService.getKnowledgeNav();
        this.investmentFundsNav = this._navService.getInvestmentFundsNav();

        // For Information Disclosure At Home Page
        this.shareholderRelationsNav = this._navService.getAboutUsShareholderRelationsNav();
        this.catInformationDisclosure = this._cateService.getCatCongBoThongTin();
        this.iDAtHomePage = [];

        if (this.investmentFundsNav && this.investmentFundsNav.children) {
          this.investmentFundsNav.children.forEach(
            (item: {
              item: NavigationItem;
              children?: {
                item: NavigationItem;
              }[];
            }) => {
              this.iDAtHomePage.push(item.item);
            },
          );
        }
        if (this.catInformationDisclosure) {
          const cateInfo = Object.assign({
            ...this.catInformationDisclosure,
            name: 'Công ty QLQ Rồng Việt',
            nameEn: 'Rong Viet Asset Management',
          });
          this.iDAtHomePage.unshift(cateInfo);
        }

        this._cdr.markForCheck();
      },
    });
  }

  openfDragon() {
    window.open('https://fdragon.vdam.com.vn/', '_blank');
  }

  // trackBy helpers for *ngFor - avoids re-rendering/re-diffing every
  // dropdown item on each change detection pass.
  trackByLinkUrl(_index: number, entry: { item: NavigationItem; children?: unknown }): string {
    return entry?.item?.linkUrl ?? _index.toString();
  }

  trackByHomePageItem(_index: number, entry: NavigationItem | CategoryItem): string {
    return (entry as NavigationItem)?.linkUrl ?? _index.toString();
  }

  async changeSiteLanguage(localeCode: string): Promise<void> {
    const selectedLanguage = this.languageList.find((language) => language.code === localeCode)?.label.toString();
    if (selectedLanguage) {
      this._stateService.currentLanguage$.next(localeCode);
      this._translate.use(localeCode);
      await this._siteLangService.createTree();
      const currentPage = this._stateService.currentPage$.getValue();
      this._stateService.changeSiteLanguage$.next(currentPage);
    }
  }

  checkQuanHeCoDongAboutUs(item: NavigationItem | CategoryItem) {
    if ((item as CategoryItem).navigationCode) {
      if ((item as CategoryItem).navigationCode === CODE_PAGE_QUAN_HE_CO_DONG) {
        return true;
      }
    }
    return false;
  }

  expandMenu(id: number) {
    this.expandMenuId = id == this.expandMenuId ? -1 : id;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close(close: any): void {
    close.preventDefault();
    this.isCloseMenu.emit(true);
  }

  checkShowOnMenu(item: NavigationItem | CategoryItem) {
    if ((item as NavigationItem).status && (item as NavigationItem).showMenu) {
      return true;
    }
    return false;
  }
}
